import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./instrumentosArchivisticos.css";
import { Interes_item } from "../../json/instrumentosarchivisticos";

const InstrumentosArchivisticos = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const linkStyle = {
    textDecoration: "none",
  };

  return (
    <div className="container instrumentos-container">
      <div className="row">
        <div className="col_12">
          <div className="instrumento_title">
            <h1>Instrumentos Archivísticos</h1>
          </div>
        </div>
      </div>
      <div className="row">
        {Interes_item.map((item, index) => (
          <div key={index} className="col-md-4 instrumentos-card">
            <Link style={linkStyle} to={item.url}>
            <div className='intrmentos_container'>
                    <h3>{ item.nombre }</h3>
                  </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InstrumentosArchivisticos;